import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';
import { isEmpty } from '@utils/validationUtils';

import { IPersonAdditionalInformationInfo } from '.';

export const initialValues = {
  gender: '',
  maritalStatus: '',
  spouseFullName: '',
  spouseProfession: '',
  fatherName: '',
  motherName: '',
  countryOfBirth: '',
  cityOfBirth: '',
  civilRegisterPlace: '',
  civilRegisterNumber: '',
  nationalityID: '',
  passportNumber: '',
  secondNationality: ''
};

export const getInputs = (
  values: IPersonAdditionalInformationInfo = initialValues,
  lovs: Record<string, Record<string, string>>,
  type: string
): IDynamicFormWidgetSection[] => [
  {
    inputs: {
      gender: {
        name: 'gender',
        title: 'Gender',
        type: FormFieldType.select,
        placeholder: 'Gender',
        value: !isEmpty(values.gender) ? values.gender : null,
        hidden: false,
        disabled: false,
        selectOptions: lovs.genders || {}
      },
      maritalStatus: {
        name: 'maritalStatus',
        title: 'Marital Status',
        placeholder: 'Marital Status',
        type: FormFieldType.select,
        value: !isEmpty(values.maritalStatus) ? values.maritalStatus : null,
        hidden: false,
        disabled: false,
        selectOptions: lovs.maritalStatuses || {}
      },
      spouseFullName: {
        name: 'spouseFullName',
        title: 'Spouse Full Name',
        placeholder: 'Spouse Full Name',
        type: FormFieldType.text,
        value: values.spouseFullName,
        minCharacters: 2,
        maxCharacters: 100,
        hidden: false,
        disabled: false
      },
      spouseProfession: {
        name: 'spouseProfession',
        title: 'Spouse Profession',
        placeholder: 'Spouse Profession',
        type: FormFieldType.text,
        value: values.spouseProfession,
        minCharacters: 2,
        maxCharacters: 100,
        hidden: false,
        disabled: false
      },
      fatherName: {
        name: 'fatherName',
        title: 'Father Name',
        placeholder: 'Father Name',
        type: FormFieldType.text,
        value: values.fatherName,
        minCharacters: 2,
        maxCharacters: 100,
        hidden: false,
        disabled: false
      },
      motherName: {
        name: 'motherName',
        title: 'Mother Name',
        placeholder: 'Mother Name',
        type: FormFieldType.text,
        value: values.motherName,
        minCharacters: 2,
        maxCharacters: 100,
        hidden: false,
        disabled: false
      },
      countryOfBirth: {
        name: 'countryOfBirth',
        title: 'Country of Birth',
        placeholder: 'Country of Birth',
        type: FormFieldType.select,
        value: !isEmpty(values.countryOfBirth) ? values.countryOfBirth : null,
        hidden: false,
        disabled: false,
        selectOptions: lovs.countries
      },
      cityOfBirth: {
        name: 'cityOfBirth',
        title: 'City of Birth',
        placeholder: 'City of Birth',
        type: FormFieldType.text,
        value: values.cityOfBirth,
        minCharacters: 2,
        maxCharacters: 100,
        hidden: false,
        disabled: false
      },
      civilRegisterPlace: {
        name: 'civilRegisterPlace',
        title: 'Civil Register Place',
        placeholder: 'Civil Register Place',
        type: FormFieldType.text,
        value: values.civilRegisterPlace,
        minCharacters: 2,
        maxCharacters: 100,
        hidden: false,
        disabled: false
      },
      civilRegisterNumber: {
        name: 'civilRegisterNumber',
        title: 'Civil Register Number',
        placeholder: 'Civil Register Number',
        type: FormFieldType.text,
        value: values.civilRegisterNumber,
        minCharacters: 1,
        maxCharacters: 100,
        hidden: false,
        disabled: false
      },
      nationalityID: {
        name: 'nationalityID',
        title: 'Nationality ID',
        placeholder: 'Nationality ID',
        type: FormFieldType.text,
        value: values.nationalityID,
        minCharacters: 2,
        maxCharacters: 100
      },
      passportNumber: {
        name: 'passportNumber',
        title: 'Passport Number',
        type: FormFieldType.text,
        placeholder: 'Passport Number',
        value: values.passportNumber,
        minCharacters: 2,
        maxCharacters: 100,
        hidden: false,
        disabled: false
      },
      secondNationality: {
        name: 'secondNationality',
        title: 'Second Nationality',
        type: FormFieldType.select,
        placeholder: 'Second Nationality',
        value: !isEmpty(values.secondNationality)
          ? values.secondNationality
          : null,
        selectOptions: lovs.nationalities
      }
    }
  }
];
